import env from "@/config/env";

// Low-level WooCommerce Store API client. The Store API is public/read-friendly
// (no consumer keys needed for browsing) which is the correct surface for a
// headless storefront. Returns null / empty on any failure so the UI can fall
// back to professional empty states instead of crashing.
async function request(path, params = {}) {
  const base = env.woo.storeApiUrl;
  if (!base) return { data: null, res: null };
  const url = new URL(base + path);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") url.searchParams.set(k, v);
  });
  try {
    const res = await fetch(url.toString(), {
      headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) return { data: null, res };
    const data = await res.json();
    return { data, res };
  } catch (e) {
    console.warn("[woo] request failed:", e.message);
    return { data: null, res: null };
  }
}

export async function storeGet(path, params = {}) {
  const { data } = await request(path, params);
  return data;
}

// List endpoint that surfaces WooCommerce pagination headers.
export async function storeGetList(path, params = {}) {
  const { data, res } = await request(path, params);
  if (!data) return { items: [], total: 0, totalPages: 0 };
  const total = Number(res?.headers.get("x-wp-total")) || data.length;
  const totalPages = Number(res?.headers.get("x-wp-totalpages")) || 1;
  return { items: data, total, totalPages };
}
